<top-banner variant="small"></top-banner>
<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <card-section-header
              title="Inductions and Training Courses"
              icon="fas fa-list"
              [buttonLabel]="createButtonAction"
              buttonIcon="fas fa-plus"
              [showButton]="routeRole !== 'site-delegate'"
              (buttonClick)="createNewTraining()">
          </card-section-header>
          <!-- Filter -->
          <div class="form-row">
            <div class="row">
              <div class="col-md-12">
                <div class="filter-flex-row">
                  <div>
                    <label> Name:</label>
                    <text-filter-box (onFilterTextChanged)="onFilterTextChangedName($event)"></text-filter-box>
                  </div>
                  <div *ngIf="isFilterLoading" class="small-spinner">
                    <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                  </div>
                </div>
                <br>
              </div>
            </div>
            <!-- Table of results -->
            <div class="row">
              <div class="col-md-12">
                <p-table
                  [value]="training"
                  selectionMode="single"
                  [(selection)]="selectedTraining"
                  (onRowSelect)="onRowSelect($event.data)"
                  (onSort)="customSort($event)"
                  [sortField]="defaultSortField"
                  [sortOrder]="defaultSortOrder"
                  [lazy]="true"
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th [pSortableColumn]="'name'">
                        Name
                        <p-sortIcon [field]="'name'"></p-sortIcon>
                      </th>
                      <th>Type</th>
                      <th *ngIf="!isSiteOwner" [pSortableColumn]="'siteOwnerUser.skylarkUser.user.firstName'">
                        Site Owner
                        <p-sortIcon [field]="'siteOwnerUser.skylarkUser.user.firstName'"></p-sortIcon>
                      </th>
                      <th>Valid for (months)</th>
                      <th>Sites</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-training>
                    <tr [pSelectableRow]="training">
                      <td>{{ training.trainingName }}</td>
                      <td>{{ training.type | capitaliseWords }}</td>
                      <td *ngIf="!isSiteOwner">{{ training.siteOwner.firstName + ' ' + training.siteOwner.lastName }}</td>
                      <td>{{ training.validForMonths }}</td>
                      <td><span>{{training.sites.join(', ')}}</span></td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                      <td [attr.colspan]="4">No course found</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <p-paginator
            #paginator
            [rows]="pagination.size"
            [totalRecords]="pagination.totalRecords"
            [rowsPerPageOptions]="pageSizes"
            (onPageChange)="paginate($event)">
          </p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
